import axios from 'lib/axios';


const getFaal = async () => {
  const { data } = await axios.get(`/divine`);
  return data;
};

const getSharedFaalUrl = async (fid) => {
  const { data } = await axios.get(`/shared/faal?fid=${fid}`);
  return data;
};



export { getFaal, getSharedFaalUrl };
